function o(n, r) {
  return n === r ? !0 : !n || !r ? !1 : JSON.stringify(n) === JSON.stringify(r);
}
function i(n, r) {
  if (n === r) return !0;
  if (!n || !r || n.length !== r.length) return !1;
  for (let l = 0; l < n.length; l++) {
    const t = n[l], e = r[l];
    if (t !== e && (t.id !== e.id || t.title !== e.title || t.label !== e.label || t.icon !== e.icon || t.radioType !== e.radioType || t.location?.lat !== e.location?.lat || t.location?.lng !== e.location?.lng || t.badge?.text !== e.badge?.text || t.badge?.color !== e.badge?.color || t.badge?.textColor !== e.badge?.textColor || t.tooltipKey !== e.tooltipKey || !o(t.metadata, e.metadata)))
      return !1;
  }
  return !0;
}
function a(n, r) {
  if (n === r) return !0;
  if (!n || !r || n.length !== r.length) return !1;
  for (let l = 0; l < n.length; l++) {
    const t = n[l], e = r[l];
    if (t !== e && (t.center?.lat !== e.center?.lat || t.center?.lng !== e.center?.lng || t.radius !== e.radius || t.color !== e.color || t.count !== e.count || t.title !== e.title || t.tooltipKey !== e.tooltipKey))
      return !1;
  }
  return !0;
}
export {
  a as circlesRenderEqual,
  i as markersRenderEqual
};
